var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-content-between overflow-hidden pb-3 h-100 w-100"},[_c('admin-tab',{staticClass:"overflow-hidden"}),_vm._v(" "),_c('admin-select-node-modal'),_vm._v(" "),_c('admin-select-relation-type-modal'),_vm._v(" "),_c('admin-table-update-modal'),_vm._v(" "),_c('admin-select-prop-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e28e7e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = null
// module chunks = 